import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Cell from '../Cell'

class CellDate extends Component {
  render() {
    const { invalidValue, locale, ...props } = this.props

    moment.locale(locale)

    return (
      <Cell
        {...props}
        render={date => {
          if (!date) {
            return invalidValue
          }

          const momentDate = moment(date)

          if (!momentDate.isValid()) {
            return invalidValue
          }

          return momentDate.calendar()
        }}
      />
    )
  }
}

CellDate.defaultProps = {
  invalidValue: '-',
  locale: 'fr',
}

CellDate.propTypes = {
  invalidValue: PropTypes.node,
  locale: PropTypes.string,
}

export default CellDate
